import React from 'react';

import { useLocalizations } from '@vp/ubik-localizations-provider';

import { finishingOptionsTabTypename } from '../types/ppV2ContentfulTypes';

import { PdpFlyoutTrigger } from './PdpFlyoutTrigger';
import { FinishingOptions, ProductFinishingOptionsData } from './product-finishing-options';
export type FinishingOptionsWrapperProps = {
  productKey: string;
  data: ProductFinishingOptionsData;
};
export const FinishingOptionsWrapper: React.FC<FinishingOptionsWrapperProps> = (props) => {
  const { t } = useLocalizations();

  return (
    <FinishingOptions
      {...props}
      trigger={
        <PdpFlyoutTrigger
          iconType="designEducation"
          label={t('product-options')}
          flyoutType={finishingOptionsTabTypename}
          productKey={props.productKey}
        />
      }
    />
  );
};
